import { Route } from "@angular/router";

export const appRoutes: Route[] = [
  { path: "", loadComponent: () => import("./contents/frontpage/frontpage.component") },
  { path: "company", loadComponent: () => import("./contents/company/company.component") },
  { path: "privacy", loadComponent: () => import("./contents/privacy/privacy.component") },
  { path: "access", loadComponent: () => import("./contents/access/access.component") },
  { path: "business", loadComponent: () => import("./contents/business/business.component") },
  { path: "history", loadComponent: () => import("./contents/history/history.component") },
  { path: "philosophy", loadComponent: () => import("./contents/philosophy/philosophy.component") },
];
